/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Partner_Detail_Periods_Meta_OneInputs */



/**
* | output |
* | --- |
* | "1 period closed in {month}" |
*
* @param {Partner_Detail_Periods_Meta_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_periods_meta_one = /** @type {((inputs: Partner_Detail_Periods_Meta_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Periods_Meta_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`1 Zeitraum in ${i?.month} abgeschlossen`)
	return /** @type {LocalizedString} */ (`1 period closed in ${i?.month}`)
});